import React, { Component } from 'react';
import Tween from 'gsap';

import './css/App.css';
import './css/normalize.css';

class App extends Component {

  componentDidMount(){
    var timeline = new Tween.TimelineLite();
    timeline.fromTo(this.refs.welcome, 0.5, {autoAlpha: 0}, {autoAlpha: 1, delay: 0.5});
    timeline.fromTo(this.refs.name, 1, {y: 50, autoAlpha: 0}, {y: 0, autoAlpha: 1, delay: 0.3});
    timeline.fromTo(this.refs.portfolio, 0.8, {autoAlpha: 0}, {autoAlpha: 1});
    timeline.fromTo(this.refs.body, 0.5, {autoAlpha: 0}, {autoAlpha: 1, delay: 1});
    timeline.fromTo(this.refs.contactBody, 0.5, {autoAlpha: 0}, {autoAlpha: 1, delay: 0.5});
    timeline.fromTo(this.refs.email, 0.5, {autoAlpha: 0}, {autoAlpha: 1});
    timeline.play();
  }

  render() {
    return (
      <div className="landing">
        <div className="landingText">
         <h2 ref="welcome">Welcome to</h2>
         <h1 className="name" ref="name">Marco Donnici's</h1>
         <h2 ref="portfolio">Portfolio</h2>
         <br />
         <p className="body" ref="body">It's still under-construction, but thank you for your interest!</p>
         <br />
         <h2 ref="contactBody">You can reach me at...</h2>
         <a ref="email" href="mailto:contact@marcod.codes">contact@marcod.codes</a>
         </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js